import Axios from 'axios'

export default Axios.create({
  baseURL: 'https://pcm.sandi.net/apiserver/api.rsc/',
  headers: {'x-cdata-authtoken':'9e0O6i3w4D8n7u9Q2z8x'}
})


// WEBPACK FOOTER //
// ./src/utils/Ajax.js